import { useTranslation } from "react-i18next";
import ActionButton from "./ActionButton";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { useDispatch, useSelector } from "react-redux";
import { setManualPaymentStep1Params } from "@/features/modals/modalsSlice";
import { selectActiveBuildingId } from '@/features/building/buildingSlice';

const ActionButtonManualPayment = ({
  channelId,
}) => {
  const buildingId = useSelector(selectActiveBuildingId);
  const { t } = useTranslation();
  const dispatch = useDispatch()

  return (
    <ActionButton
      color="secondary"
      startIcon={<CreditCardIcon/>}
      onClick={ () => dispatch(setManualPaymentStep1Params({
        buildingId,
        channelId,
      })) }
    >
      { t('payment_manual') }
    </ActionButton>
  )
}

export default ActionButtonManualPayment